/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindTypeKeysQueryResponse,
  FindTypeKeysQueryParams,
} from "../types/FindTypeKeys.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findTypeKeysQueryKey = (params: FindTypeKeysQueryParams) =>
  [
    { url: "/v1/client-settings/find-type-keys" },
    ...(params ? [params] : []),
  ] as const

export type FindTypeKeysQueryKey = ReturnType<typeof findTypeKeysQueryKey>

/**
 * @summary Find type keys
 * {@link /v1/client-settings/find-type-keys}
 */
export async function findTypeKeys(
  params: FindTypeKeysQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTypeKeysQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-type-keys`,
    params,
    ...requestConfig,
  })
  return res
}

export function findTypeKeysQueryOptions(
  params: FindTypeKeysQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTypeKeysQueryKey(params)
  return queryOptions<
    ResponseConfig<FindTypeKeysQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTypeKeysQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findTypeKeys(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find type keys
 * {@link /v1/client-settings/find-type-keys}
 */
export function useFindTypeKeys<
  TData = ResponseConfig<FindTypeKeysQueryResponse>,
  TQueryData = ResponseConfig<FindTypeKeysQueryResponse>,
  TQueryKey extends QueryKey = FindTypeKeysQueryKey,
>(
  params: FindTypeKeysQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTypeKeysQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findTypeKeysQueryKey(params)

  const query = useQuery(
    {
      ...findTypeKeysQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
